import BaseRequestModel from './utils/base-request-model';

 const ApiService = {
  
  // GET REQ
   
   get: (route) => {
     try {
      const userData = localStorage.getItem("persist:root")
      let params = JSON.parse(userData)["userCredentials"]
      let token = JSON.parse(params).token;
     const headers = {
       'Access-Control-Allow-Origin': '*',
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${token}`
     };
     const newBase = new BaseRequestModel(route, 'GET', headers);
       return newBase.request();
     } catch (err) {
       throw JSON.stringify(err);
     }
    },

    
    // POST REQ
   post: (route, form) => {
     try {
      const userData = localStorage.getItem("persist:root")
      let params = JSON.parse(userData)["userCredentials"]
       let token = JSON.parse(params).token;
        const headers = {
          'Content-Type': 'application/json',
          'Authorization':`Bearer ${token}`
        };
        const newBase = new BaseRequestModel(route, 'POST', headers, form);
       return newBase.request();
     } catch (err) {
       throw JSON.stringify(err);
     }
   },
   //request file via post
   file: (route, form,) => {
     try {
       const userData = localStorage.getItem("persist:root")
       let params = JSON.parse(userData)["userCredentials"]
       let token = JSON.parse(params).token;
       const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`
       };
       const newBase = new BaseRequestModel(route, 'POST', headers, form, 'blob');
       return newBase.request();
     } catch (err) {
       throw JSON.stringify(err);
     }
   },
   fileGet: (route) => {
     try {
       const userData = localStorage.getItem("persist:root")
       let params = JSON.parse(userData)["userCredentials"]
       let token = JSON.parse(params).token;
       const headers = {
         'Content-Type': 'blob',
         'Authorization': `Bearer ${token}`
       };
       const newBase = new BaseRequestModel(route, 'GET', headers, '', 'blob');
       return newBase.request();
     } catch (err) {
       throw JSON.stringify(err);
     }
   }
  }
  export default ApiService;